<ul>
  <li *ngFor="let item of inner_17025_Cat" class="MyMoeinListCat_Li">

    <div class="MyMoeinListCat_Div">

      <i class="fa fa-folder-o" style="visibility: visible !important;" *ngIf="item.chart_type==1"></i>
      <i class="fa fa-list-alt" style="visibility: visible !important;" *ngIf="item.chart_type==2"></i>
      <i class="fa  fa-file-text" style="visibility: visible !important;" *ngIf="item.chart_type==3"></i>

      <span class="MyMoeinListCat_Span">{{item.title}}
        <span *ngIf="item.code">({{item.code}})</span>
      </span>

      <i class="fa fa-eye" *ngIf="item.chart_type==1 && item.child.length>0 && item.childVisible" style="visibility: visible !important;" (click)="Change_Visible(item)"></i>
      <i class="fa fa-eye-slash" style="visibility: visible !important;" *ngIf="item.child.length>0 && !item.childVisible && item.chart_type==1" (click)="Change_Visible(item)"></i>

      <i title="بالا" class="fa fa-arrow-circle-up" (click)="OnSet_Up_Action(item)"></i>
      <i title="پایین" class="fa fa-arrow-circle-down"  (click)="OnSet_Down_Action(item)"></i>
      <i title="فرزند" class="fa fa-cut"  (click)="OnSet_Child_Action(item)"></i>
      <i title="انتقال" class="fa fa-paste"  (click)="OnSet_Cut_Action(item)"></i>

      <i title="افزودن گام" *ngIf="item.chart_type==1" class="fa  fa-plus-circle MyMoeinListCat_Add" style="margin-right: 10px;" (click)="OnSet_Add_Action(item)"></i>
      <i title="افزودن دستور عمل" *ngIf="item.chart_type==1" class="fa fa-plus-square MyMoeinListCat_Add" (click)="OnSet_Add_Protocol_Action(item)"></i>
      <i title="افزودن فرم" *ngIf="item.chart_type==1" class="fa fa-plus MyMoeinListCat_Add" (click)="OnSet_Add_Form_Action(item)"></i>


      <i title="جزئیات" *ngIf="item.chart_type==2" class="fa fa-cloud" (click)="OnSet_File_Action(item)" style="margin-right: 10px;color: rgb(124, 151, 24);"></i>
      <i title="سابقه" *ngIf="item.chart_type==3" class="fa fa-history" (click)="OnSet_File_Action(item)" style="margin-right: 10px;color: rgb(124, 151, 24);"></i>


      <i title="ویرایش" class="fa  fa-edit MyMoeinListCat_Edit" (click)="OnSet_Edit_Action(item)" style="margin-right: 10px;"></i>
      <i title="حذف" class="fa  fa-remove MyMoeinListCat_Remove" (click)="OnSet_Remove_Action(item)"></i>




    </div>

    <app-Protocol17025Chart_Co
      [hidden]="item.childVisible==false"
      (On_Add_Action)="OnSet_Add_Action($event)"
      (On_Edit_Action)="OnSet_Edit_Action($event)"
      (On_Remove_Action)="OnSet_Remove_Action($event)"
      (On_Up_Action)="OnSet_Up_Action($event)"
      (On_Down_Action)="OnSet_Down_Action($event)"
      (On_Cut_Action)="OnSet_Cut_Action($event)"
      (On_Child_Action)="OnSet_Child_Action($event)"
      (On_File_Action)="OnSet_File_Action($event)"
      [inner_17025_Cat]="item.child">

    </app-Protocol17025Chart_Co>

  </li>
</ul>
